import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";

const serviceType = [
  { value: "TopUp_SMS", label: "Top Up SMS" },
  { value: "TOPUP_RCS", label: "Top Up RCS" },
];

const MainWalletFilterModal = ({
  show,
  handleClose,
  setFilterData,
  filterData,
  handleReset,
  setWalletHistoryData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      actionType: filterData.actionType || "",
      minTxnAmount: filterData.minTxnAmount || "",
      maxTxnAmount: filterData.maxTxnAmount || "",
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("Action Type");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const fetchCusWalletHistoryData = async (data, pageNo) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        actionType: data.actionType,
        minTxnAmount: data.minTxnAmount,
        maxTxnAmount: data.maxTxnAmount,
        fromDate: formatDate(data.fromDate),
        toDate: formatDate(data.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.Fetch_CusWallet_History}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setWalletHistoryData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
          CustomAlert({
            title: "Failed",
            text: "No transactions matched the selected filters.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setWalletHistoryData([]);
        CustomAlert({
          title: "Failed",
          text: "No transactions matched the selected filters.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      transactionDate: item.transactionDate?.split(" ")?.[0],
      id: index + 1,
    }));
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchCusWalletHistoryData(data, currentPage);
    handleClose();
  };

  const onReset = () => {
    reset({
      actionType: "",
      minTxnAmount: "",
      maxTxnAmount: "",
      fromDate: "",
      toDate: "",
    });
    setFilterData({
      actionType: "",
      minTxnAmount: "",
      maxTxnAmount: "",
      fromDate: "",
      toDate: "",
    });
    handleReset();
    fetchCusWalletHistoryData(
      {
        actionType: "",
        minTxnAmount: "",
        maxTxnAmount: "",
        fromDate: "",
        toDate: "",
      },
      1
    );
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h5 className="modal-title main-title">Top-Up SMS/RCS</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Action Type", "Total Amount", "Transaction Date"].map(
                        (tab) => (
                          <div className="tab-wrapper" key={tab}>
                            <li
                              className={
                                selectedTab === tab
                                  ? "tab-item selected"
                                  : "tab-item"
                              }
                            >
                              <button
                                className={`tab-button ${
                                  selectedTab === tab ? "active" : ""
                                }`}
                                onClick={(e) => handleTabChange(e, tab)}
                              >
                                {tab}
                              </button>
                            </li>
                            {selectedTab === tab && (
                              <img
                                src={ButtonTriangle}
                                alt="tri"
                                className="tab-triangle"
                              />
                            )}
                          </div>
                        )
                      )}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "Action Type" && (
                        <div className="dateField">
                          <label className="dateLabel">Action Type</label>
                          <div className="dateInputWrapper">
                            <Controller
                              name="actionType"
                              control={control}
                              render={({ field }) => (
                                <select
                                  {...field}
                                  className="dateInput"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      actionType: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="">Select Action Type</option>
                                  {serviceType.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Total Amount" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            gap: "16px",
                            flexDirection: "row",
                          }}
                        >
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">From Amount</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="minTxnAmount"
                                control={control}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    type="number"
                                    placeholder="0.00"
                                    min="0"
                                    className="dateInput"
                                    onKeyDown={(e) => {
                                      if (["-", "+", "e"].includes(e.key))
                                        e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (
                                        /^\d*\.?\d*$/.test(val) ||
                                        val === ""
                                      ) {
                                        field.onChange(val);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          minTxnAmount: val,
                                        }));
                                      }
                                    }}
                                    value={field.value || ""}
                                  />
                                )}
                              />
                            </div>
                          </div>

                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">To Amount</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="maxTxnAmount"
                                control={control}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    type="number"
                                    placeholder="0.00"
                                    min="0"
                                    className="dateInput"
                                    onKeyDown={(e) => {
                                      if (["-", "+", "e"].includes(e.key))
                                        e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (
                                        /^\d*\.?\d*$/.test(val) ||
                                        val === ""
                                      ) {
                                        field.onChange(val);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          maxTxnAmount: val,
                                        }));
                                      }
                                    }}
                                    value={field.value || ""}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {selectedTab === "Transaction Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">From Date</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="fromDate"
                                control={control}
                                rules={{
                                  validate: {
                                    validDate: (value) =>
                                      !value ||
                                      !isNaN(Date.parse(value)) ||
                                      "Invalid From Date",
                                    notFuture: (value) =>
                                      !value ||
                                      new Date(value) <= new Date() ||
                                      "From Date cannot be in the future",
                                    beforeToDate: (value, formValues) =>
                                      !value ||
                                      !formValues.toDate ||
                                      new Date(value) <=
                                        new Date(formValues.toDate) ||
                                      "From Date must be before To Date",
                                    requiredIfToDate: (value, formValues) =>
                                      !formValues.toDate ||
                                      !!value ||
                                      "From Date is required when To Date is selected",
                                  },
                                }}
                                render={({ field }) => (
                                  <div>
                                    <input
                                      {...field}
                                      type="date"
                                      className="dateInput"
                                      max={getTodayDate()}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          fromDate: e.target.value,
                                        }));
                                      }}
                                    />
                                    {errors.fromDate && (
                                      <span className="error-text">
                                        {errors.fromDate.message}
                                      </span>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </div>

                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">To Date</label>
                            <div className="dateInputWrapper">
                              <Controller
                                name="toDate"
                                control={control}
                                rules={{
                                  validate: {
                                    validDate: (value) =>
                                      !value ||
                                      !isNaN(Date.parse(value)) ||
                                      "Invalid To Date",
                                    notFuture: (value) =>
                                      !value ||
                                      new Date(value) <= new Date() ||
                                      "To Date cannot be in the future",
                                    afterFromDate: (value, formValues) =>
                                      !value ||
                                      !formValues.fromDate ||
                                      new Date(value) >=
                                        new Date(formValues.fromDate) ||
                                      "To Date must be after From Date",
                                    requiredIfFromDate: (value, formValues) =>
                                      !formValues.fromDate ||
                                      !!value ||
                                      "To Date is required when From Date is selected",
                                  },
                                }}
                                render={({ field }) => (
                                  <div>
                                    <input
                                      {...field}
                                      type="date"
                                      className="dateInput"
                                      max={getTodayDate()}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          toDate: e.target.value,
                                        }));
                                      }}
                                    />
                                    {errors.toDate && (
                                      <span className="error-text">
                                        {errors.toDate.message}
                                      </span>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={isSubmitting || loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MainWalletFilterModal;